import { Modal } from 'antd';
import classNames from 'classnames/bind';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import Slider from 'react-slick';
// import { IMAGES } from '~/assets/assetsPath';
import InputPhoneModal from '~/components/FormInputPhone';
import config from '~/config';
import styles from './BannerHome.module.scss';
import { useSelector } from 'react-redux';

const cx = classNames.bind(styles);

const settings = {
    dots: true,
    infinite: true,
    dotsClass: styles.button__bar,
    draggable: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoPlay: true,
    autoplay: true,
    // autoplaySpeed: 2000,
    pauseOnHover: false,
};

function BannerHome({ bannerList, ...props }) {
    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';
    // const isLogin = !!localStorage.getItem('token');
    // const bannerData = [1, 2, 3];
    const navigate = useNavigate();

    const [isShowInputPhone, setIsShowInputPhone] = useState(false);

    const handleOnBookingNow = () => {
        if (isLogin) {
            navigate(config.routes.createSchedulePage);
        } else {
            setIsShowInputPhone(true);
        }
    };
    const handleClickBanner = (index) => {
        if (index === 2) {
            if (isLogin) {
                navigate(config.routes.createSchedulePage);
            } else {
                setIsShowInputPhone(true);
            }
        }
    };

    const onRejectInputPhone = () => {
        setIsShowInputPhone(false);
    };
    const onAgreeInputPhone = () => {
        setIsShowInputPhone(false);
        navigate(config.routes.createSchedulePage);
    };

    return (
        <div className={cx('slider')}>
            <Slider {...settings}>
                {bannerList?.map((item, index) => (
                    <div key={index} className={cx('banner')}>
                        {index === 0 && props?.isDesktop ? (
                            <a href="https://vbeauty.app.link/download" target="blank">
                                <img src={item.image} alt="banner" />
                            </a>
                        ) : index === 1 && !props?.isDesktop ? (
                            <a href="https://vbeauty.app.link/download" target="blank">
                                <img src={item.image} alt="banner" />
                            </a>
                        ) : (
                            <img src={item.image} alt="banner" onClick={() => handleClickBanner(index)} />
                        )}

                        {/* {index === 0 ? (
                            <div className={cx('content-wrapper')}>
                                <p className={cx('title-1')}>Welcome</p>
                                <p className={cx('title-2')}>Beauty-ms</p>
                                <p className={cx('description')}>
                                    With skilled and experienced specialists, dedicated and thoughtful to take care of your needs
                                    Fully enjoy high quality services
                                </p>

                                <button className={cx('btn')} onClick={handleOnBookingNow}>
                                    Schedule now
                                </button>
                            </div>
                        ) : (
                            ''
                        )} */}
                    </div>
                ))}
            </Slider>
            {isShowInputPhone && (
                <Modal
                    centered
                    visible={isShowInputPhone}
                    onCancel={onRejectInputPhone}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={550}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <InputPhoneModal onAgreeInputPhone={onAgreeInputPhone} />
                    </div>
                </Modal>
            )}
        </div>
    );
}

export default BannerHome;
